module.exports = __webpack_public_path__ + "img/[酷].0fc276b0.svg";